var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPiggyBank = function SvgPiggyBank(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.78363 5.34082C2.19583 6.45104 2.97937 7.29138 3.77925 7.88633",
    stroke: "currentColor",
    strokeWidth: 1.995,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6078 8.70251H8.6922",
    stroke: "currentColor",
    strokeWidth: 1.995,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4537 11.0631C16.2366 11.0631 16.0607 10.8872 16.0607 10.6702C16.0607 10.4532 16.2366 10.2772 16.4537 10.2772",
    stroke: "currentColor",
    strokeWidth: 1.995,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4537 11.0631C16.6707 11.0631 16.8466 10.8872 16.8466 10.6702C16.8466 10.4532 16.6707 10.2772 16.4537 10.2772",
    stroke: "currentColor",
    strokeWidth: 1.995,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3089 3.97723V6.84217C18.8766 7.67764 19.7111 8.93947 19.7111 10.9912L22.2164 12.4V15.143C21.087 16.4698 19.2039 17.5282 17.3089 18.1539V19.859C17.3089 20.2929 16.957 20.6449 16.523 20.6449H13.9259C13.4919 20.6449 13.1401 20.2929 13.1401 19.859V18.1539H7.98588V19.859C7.98588 20.2929 7.63402 20.6449 7.19999 20.6449H4.31955C4.00097 20.6449 3.713 20.4541 3.59969 20.1562C2.41349 17.0393 1.48352 12.3346 2.93644 9.33241C3.99242 7.15044 5.71292 4.6323 12.8556 5.77471C13.6402 3.84251 15.7023 3.32346 16.7829 3.3567C17.106 3.36664 17.3089 3.6539 17.3089 3.97723Z",
    stroke: "currentColor",
    strokeWidth: 1.995,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPiggyBank);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "piggy-bank.c0894fe3bca1cce1fb7e7982122e49d8.svg";